// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2YAr-","productName":"Table_productName__2h36D"};